import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Sellers() {
  const navigate = useNavigate();
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchSellers = async (pageNum = page, limitNum = perPage) => {
    setLoading(true);
    setError(null);
    const res = await api.getSellers(pageNum, limitNum);
    if (!res) {
      setError('Failed to load sellers');
      setSellers([]);
      setTotalRows(0);
    } else {
      setSellers(res.sellers || []);
      setTotalRows(res.total || 0);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSellers(page, perPage);
    // eslint-disable-next-line
  }, [page, perPage]);

  const handlePageChange = pageNum => setPage(pageNum);
  const handlePerRowsChange = async (newPerPage, pageNum) => {
    setPerPage(newPerPage);
    setPage(pageNum);
  };

  const columns = [
    { name: 'Profile', selector: row => <img className="vendor-thumb" src={row.imageUrl || '/assets/img/vendor/u9.jpg'} alt="seller profile" />, width: '80px' },
    { name: 'Name', selector: row => row.name || '-', sortable: true },
    { name: 'Email', selector: row => row.email || '-', sortable: true },
    { name: 'Phone', selector: row => row.phone || '-', sortable: true },
    { name: 'Status', selector: row => <span className={`ec-status ${row.status === 'ACTIVE' ? 'ec-active' : row.status === 'PENDING' ? 'ec-pending' : 'ec-inactive'}`}>{row.status || '-'}</span>, sortable: true },
    { name: 'Verification', selector: row => row.verificationStatus || '-', sortable: true },
    { name: 'Join On', selector: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '-', sortable: true },
    {
      name: 'Action',
      cell: row => (
        <div className="btn-group mb-1">
          <button type="button" className="btn btn-outline-success" onClick={() => navigate(`/sellers/${row.id}`, { state: { seller: row } })}>Info</button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Sellers | Owena Admin Dashboard</title>
      </Helmet>
    <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
      <h1>Sellers</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e) => e.preventDefault()}>Home</a></span>
                <span><i className="mdi mdi-chevron-right"></i></span>Sellers</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <DataTable
                    columns={columns}
                    data={sellers}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    highlightOnHover
                    responsive
                    noHeader
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Modals removed: Sellers data is managed via backend; no local add/edit forms */}
        </div>
    </div>
    </>
  );
}

export default Sellers;
